import { Genre } from 'features/Genre/models/Genre';
import { Course } from 'features/SaleType/models/Course';
import { MenuBook } from 'features/SaleType/models/MenuBook';
import { SubGenre } from 'features/SubGenre/models/SubGenre';
import axiosClient from 'utils/axiosClient';

export interface MenuBookResponse {
  status: string;
  message: string;
  data: MenuBook[];
}

export interface CourseResponse {
  status: string;
  message: string;
  data: Course[];
}

export interface GenreResponse {
  status: string;
  message: string;
  data: Genre[];
}

export interface SubGenreResponse {
  status: string;
  message: string;
  data: SubGenre[];
}

export interface CopyRequest {
  from_menu_book_id: string | number;
  from_course_id: string | number;
  from_genre_id: string | number;
  from_sub_genre_id: string | number;
  from_menu_id: string | number;
  to_menu_book_id: string | number;
  to_course_id: string | number;
  to_genre_id: string | number;
  to_sub_genre_id: string | number;
}

const service = {
  getMenuBooks(): Promise<MenuBookResponse> {
    const url = `menubooks-modal`;
    return axiosClient.get(url);
  },
  getCourses(): Promise<CourseResponse> {
    const url = `courses-modal`;
    return axiosClient.get(url);
  },
  getGenres(menuBookId: string | number, courseId: string | number): Promise<GenreResponse> {
    const url = `get-genre-with-menubook-course-id?menu_book_id=${menuBookId}&course_id=${courseId}`;
    return axiosClient.get(url);
  },
  getSubGenres(
    genreId: string | number,
    menuBookId: string | number,
    courseId: string | number
  ): Promise<SubGenreResponse> {
    const url = `get-subgenre-by-genre?genre_id=${genreId}&menu_book_id=${menuBookId}&course_id=${courseId}`;
    return axiosClient.get(url);
  },
  copy(data: CopyRequest) {
    const url = `modal-copy-menu-book-genre-subgenre-menu`;
    return axiosClient.post(url, data);
  },
  check(data: CopyRequest) {
    const url = `check-destination-already-exits`;
    return axiosClient.post(url, data);
  },
};

export default service;
